/**
 * Created by Amit Panghal
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SASymbols, SpacierArcadeReelSymbol} from "../symbols/SpacierArcadeReelSymbol";

export class SAReelView extends PIXI.Container {
    get attentionLayer():PIXI.Container {
        return this._attentionLayer;
    }

    set attentionLayer(value:PIXI.Container) {
        this._attentionLayer = value;
    }

    get bottomLayer():PIXI.Container {
        return this._bottomLayer;
    }

    set bottomLayer(value:PIXI.Container) {
        this._bottomLayer = value;
    }

    get specialSymLayer():PIXI.Container {
        return this._specialSymLayer;
    }

    set specialSymLayer(value:PIXI.Container) {
        this._specialSymLayer = value;
    }

    private _bottomLayer:PIXI.Container;
    private _attentionLayer:PIXI.Container;
    private _specialSymLayer:PIXI.Container;

    constructor(reelId:number) {
        super();
        this._specialSymLayer = new PIXI.Container();
        this._bottomLayer = new PIXI.Container();
        this._attentionLayer = new PIXI.Container();

    }


    addChild<TChildren extends PIXI.DisplayObject[]>(...child:TChildren):TChildren[0] {
        return this._bottomLayer.addChild(child[0]);
    }
}